import { UseFormReturnType } from "@mantine/form";
import { LooseKeys, PathValue } from "@mantine/form/lib/paths.types";
import { useEffect, useState } from "react";

export function useFormSubscription<V, K extends LooseKeys<V>>(form: UseFormReturnType<V>, k: K) {
    const [v, setV] = useState(form.getInputProps(k).value);
    form.watch(k, ({ value }) => setV(value));

    useEffect(() => {
        // if K changes, immediately yield values with those at new K (don't wait for an update of the value at K)
        setV(form.getInputProps(k).value);
    }, [k]);

    return v as PathValue<V, K>;
}
